// Guards
import { GUARD_GUEST, GUARD_USER } from 'constants/guards'

// Paths
import {
  PATH_ANNOUNCEMENT_VIEW,
  PATH_ECWT_LIST,
  PATH_ECWT_VIEW,
  PATH_EXPIRED,
  PATH_WHITELIST_PASSWORD_RESET,
  PATH_FORGOT_PASSWORD,
  PATH_FORGOT_PASSWORD_SUCCESS,
  PATH_HOME,
  PATH_LOGIN,
  PATH_MY_ACCOUNT,
  PATH_NOT_FOUND,
  PATH_PAYMENT_CONTRACT,
  PATH_PAYMENT_VIEW,
  PATH_PROFILE,
  PATH_REGISTER,
  PATH_REGISTER_EXISTED,
  PATH_RESET_PASSWORD,
  PATH_TICKET_SUPPORT,
  PATH_TICKET_LIST_CLOSED,
  PATH_TICKET_VIEW,
} from './paths'

// Pages
import PageNotFound from 'pages/Errors/NotFound'
import PageExpired from 'pages/Errors/Expired'
import PageHome from 'pages/Home'
import PageLogin from 'pages/Auth/Login'
import PageRegister from 'pages/Register/Register'
import PageRegisterExisted from 'pages/Register/RegisterExisted'
import PageForgotPassword from 'pages/Password/ForgotPassword'
import PageResetPassword from 'pages/Password/ResetPassword'
import PageForgotPasswordSuccess from 'pages/Password/ForgotPasswordSuccess'
import PageWhitelistResetPassword from 'pages/Password/WhitelistResetPassword'
import PageMyAccount from 'pages/MyAccount'
import PageProfile from 'pages/Profile'
import PageAnnouncementView from 'pages/Announcement/AnnouncementView'
import PagePaymentView from 'pages/Payment/PaymentView'
import PageContractView from 'pages/Payment/ContractView'
import PageEcwtList from 'pages/Ecwt/EcwtList'
import PageEcwtView from 'pages/Ecwt/EcwtView'
import PageTicketsSupport from 'pages/Ticketing/Support'
import PageTicketsArchived from 'pages/Ticketing/TicketsArchived'
import PageTicketsView from 'pages/Ticketing/TicketsView'

export default [
  // Home
  {
    path: PATH_HOME,
    exact: true,
    component: PageHome,
    guard: GUARD_USER,
    title: 'Home',
  },

  // Register
  {
    path: PATH_REGISTER,
    component: PageRegister,
    guard: GUARD_GUEST,
    exact: true,
    title: 'Register',
  },

  {
    path: PATH_REGISTER_EXISTED,
    component: PageRegisterExisted,
    guard: GUARD_GUEST,
    title: 'Register - Existed',
  },

  // Auth
  {
    path: PATH_LOGIN,
    component: PageLogin,
    guard: GUARD_GUEST,
    title: 'Auth - Login',
  },

  // Password
  {
    path: PATH_FORGOT_PASSWORD,
    component: PageForgotPassword,
    guard: GUARD_GUEST,
    title: 'Password - Forgot',
  },

  {
    path: PATH_WHITELIST_PASSWORD_RESET,
    component: PageWhitelistResetPassword,
    guard: GUARD_GUEST,
    title: 'Password - Whitelist Reset',
  },

  {
    path: PATH_RESET_PASSWORD,
    component: PageResetPassword,
    guard: GUARD_GUEST,
    title: 'Password - Reset',
  },

  {
    path: PATH_FORGOT_PASSWORD_SUCCESS,
    component: PageForgotPasswordSuccess,
    guard: GUARD_GUEST,
    title: 'Password - Reset success',
  },

  // My account
  {
    path: PATH_MY_ACCOUNT,
    component: PageMyAccount,
    guard: GUARD_USER,
    exact: true,
    title: 'My account',
  },

  {
    path: PATH_PROFILE,
    component: PageProfile,
    guard: GUARD_USER,
    title: 'Profile',
    exact: true,
  },

  // Announcement
  {
    path: PATH_ANNOUNCEMENT_VIEW,
    component: PageAnnouncementView,
    guard: GUARD_USER,
    title: 'Announcement - View',
  },

  // Payment
  {
    path: PATH_PAYMENT_CONTRACT,
    component: PageContractView,
    guard: GUARD_USER,
    title: 'Payment - Contract',
  },

  {
    path: PATH_PAYMENT_VIEW,
    component: PagePaymentView,
    guard: GUARD_USER,
    title: 'Payment - View',
  },

  // Ecwt
  {
    path: PATH_ECWT_VIEW,
    component: PageEcwtView,
    guard: GUARD_USER,
    title: 'Ecwt - View',
  },

  {
    path: PATH_ECWT_LIST,
    component: PageEcwtList,
    guard: GUARD_USER,
    title: 'Ecwt - List',
  },

  // Ticketing
  {
    path: PATH_TICKET_LIST_CLOSED,
    component: PageTicketsArchived,
    guard: GUARD_USER,
    title: 'Ticketing - Archived',
  },
  {
    path: PATH_TICKET_VIEW,
    component: PageTicketsView,
    guard: GUARD_USER,
    title: 'Ticketing - View',
  },
  {
    path: PATH_TICKET_SUPPORT,
    component: PageTicketsSupport,
    guard: GUARD_USER,
    exact: true,
    title: 'Ticketing - Support',
  },
  {
    path: PATH_TICKET_LIST_CLOSED,
    component: PageTicketsArchived,
    guard: GUARD_USER,
    title: 'Support - Archived',
  },

  // Errors
  {
    path: PATH_EXPIRED,
    component: PageExpired,
    title: 'Error - Expired',
  },

  {
    path: PATH_NOT_FOUND,
    component: PageNotFound,
    title: 'Error - 404',
  },
]
